"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 13 11';

var ToggleNav = function ToggleNav() {
  return _react["default"].createElement("g", {
    transform: "rotate(90) translate(0, -12)"
  }, _react["default"].createElement("path", {
    d: "M10.7788,1.28415 L0.9243,1.28415 C0.6163,1.28415 0.3668,1.03465 0.3668,0.72665 C0.3668,0.41915 0.6163,0.16915 0.9243,0.16915 L10.7788,0.16915 C11.0868,0.16915 11.3363,0.41915 11.3363,0.72665 C11.3363,1.03465 11.0868,1.28415 10.7788,1.28415"
  }), _react["default"].createElement("path", {
    d: "M10.0693,1.9536 L1.5933,1.9536 C0.7923,1.9536 0.1433,2.6026 0.1433,3.4031 L0.1433,10.0946 C0.1433,10.8956 0.7923,11.5451 1.5933,11.5451 L10.0693,11.5451 C10.8703,11.5451 11.5188,10.8956 11.5188,10.0946 L11.5188,3.4031 C11.5188,2.6026 10.8703,1.9536 10.0693,1.9536 M10.0693,3.0686 C10.2538,3.0686 10.4038,3.2186 10.4038,3.4031 L10.4038,10.0946 C10.4038,10.2791 10.2538,10.4296 10.0693,10.4296 L1.5933,10.4296 C1.4088,10.4296 1.2588,10.2791 1.2588,10.0946 L1.2588,3.4031 C1.2588,3.2186 1.4088,3.0686 1.5933,3.0686 L10.0693,3.0686"
  }), _react["default"].createElement("path", {
    d: "M8.6792,6.4243 L6.2262,3.9713 C6.2002,3.9448 6.1712,3.9213 6.1402,3.9008 C6.1272,3.8928 6.1137,3.8868 6.1007,3.8793 C6.0822,3.8693 6.0642,3.8578 6.0442,3.8498 C6.0262,3.8423 6.0082,3.8383 5.9897,3.8328 C5.9732,3.8283 5.9577,3.8218 5.9402,3.8183 C5.8682,3.8038 5.7937,3.8038 5.7222,3.8183 C5.7052,3.8218 5.6897,3.8283 5.6727,3.8328 C5.6542,3.8383 5.6357,3.8423 5.6182,3.8498 C5.5987,3.8578 5.5807,3.8693 5.5622,3.8793 C5.5487,3.8868 5.5347,3.8928 5.5222,3.9008 C5.4912,3.9213 5.4622,3.9448 5.4367,3.9713 L2.9832,6.4243 C2.7657,6.6423 2.7657,6.9948 2.9832,7.2128 C3.0922,7.3218 3.2347,7.3758 3.3777,7.3758 C3.5207,7.3758 3.6632,7.3218 3.7722,7.2128 L5.2732,5.7108 L5.2732,9.1183 C5.2732,9.4263 5.5232,9.6758 5.8312,9.6758 C6.1392,9.6758 6.3887,9.4263 6.3887,9.1183 L6.3887,5.7108 L7.8907,7.2128 C7.9997,7.3218 8.1422,7.3758 8.2847,7.3758 C8.4272,7.3758 8.5702,7.3218 8.6792,7.2128 C8.8972,6.9948 8.8972,6.6423 8.6792,6.4243"
  }));
};

var _default = (0, _createSvgIcon["default"])(ToggleNav, {
  viewBox: viewBox
});

exports["default"] = _default;